import React from 'react';

export default function BounceLoader() {
  return (
    <div className="loading" data-name="bounce-loader">
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/BounceLoader.js